import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { Container, Row, Col, Alert } from "react-bootstrap";
import { Helmet } from "react-helmet-async";

const PasswordResetRedirectPage = () => {
  const [emailFound, setEmailFound] = useState(false);
  const [emailNotFound, setEmailNotFound] = useState(false);
  const [somethingWentWrong, setSomethingWentWrong] = useState(false);

  let navigate = useNavigate();

  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
  const uuidCode = searchParams.get("uuid-code");
  console.log("uuidCode", uuidCode);

  useEffect(() => {
    fetchData();
  }, []);

  const bodyData = {
    uniqueIdForPasswordReset: uuidCode,
  };

  const fetchData = async () => {
    const response = await fetch(process.env.REACT_APP_PASSWORD_RESET, {
      method: "POST",
      headers: {
        "Content-type": "application/json",
        /* Authorization: `Bearer ${token}`, */
      },
      body: JSON.stringify(bodyData),
    });
    if (response.status === 201) {
      console.log(response.status);

      setEmailFound(true);
      setTimeout(() => {
        navigate("/generate-new-password");
      }, "3000");
    } else if (response.status === 204) {
      console.log(response.status);
      setEmailNotFound(true);
      setTimeout(() => {
        navigate("/");
      }, "3000");
    } else {
      setSomethingWentWrong(true);
      setTimeout(() => {
        navigate("/");
      }, "3000");
    }
  };

  return (
    <Container fluid>
      <Row>
        <Col xs={12} align="center">
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Helmet>
              <style>{"body { background-color: #264068; }"}</style>
            </Helmet>

            {emailFound && (
              <div>
                <Alert variant="success">
                  Thank you. You will now be redirected. 📬
                </Alert>
              </div>
            )}
            {emailNotFound && (
              <div>
                <Alert variant="warning">
                  Email was not found in the database. Please try again. We will
                  now redirect you.
                </Alert>
              </div>
            )}
            {somethingWentWrong && (
              <div
                style={
                  {
                    /*  position: "absolute",
                  left: "50%",
                  transform: "translate(-50%, 0)", */
                  }
                }
              >
                <Alert variant="danger">
                  Something went wrong. Please contact us on
                  contact@serpmaze.com . We will now redirect you.
                </Alert>
              </div>
            )}
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default PasswordResetRedirectPage;
